import { Box } from "@mui/material";
import { FC, ReactNode } from "react";

interface DefaultPageProps {
  children: ReactNode;
}

const DefaultPage: FC<DefaultPageProps> = ({ children }) => {
  return (
    <Box
      className="flex flex-col w-screen h-screen justify-start items-center gap-6 overflow-x-hidden"
      sx={{
        marginTop: {
          xs: "1rem",
        },
      }}
    >
      {children}
    </Box>
  );
};

export default DefaultPage;
